/**
 * Get restaurant ID from cookies on the client side
 */
export function getRestaurantIdClient(): string | undefined {
  if (typeof document === 'undefined') return undefined;

  const cookies = document.cookie.split(';');
  const restaurantCookie = cookies.find(c => c.trim().startsWith('restaurant_id='));
  const value = restaurantCookie?.split('=').slice(1).join('=');
  if (!value) return undefined;

  try {
    return decodeURIComponent(value);
  } catch (error) {
    console.warn('[getRestaurantIdClient] Failed to decode restaurant_id cookie', error);
    return value;
  }
}

export function redirectToLoginIfNoRestaurant(): boolean {
  if (typeof window === 'undefined') return false;
  if (getRestaurantIdClient()) return false;
  window.location.href = '/';
  return true;
}
